App.Pages.ChangePass = class ChangePass extends PF.Page
	{

	static get options()
		{
		return {
			rights: {
				user: true
			},
			path: '/change-pass',
			nameRu: 'Общее - изменение пароля',
		};
		}

	static get template()
		{
		// language=HTML
		return `
			<div class="page">
				<div class="navbar">
					<div class="navbar-bg"></div>
					<div class="navbar-inner">
						<div class="left">
							<a href="#" class="link back">
								<i class="icon icon-back"></i>
							</a>
						</div>
						<div class="center">Изменить пароль</div>
					</div>
				</div>

				<div class="page-content">

					<div class="stretch-block">
						<form class="block" pf="changePassForm">
							<input type="password" placeholder="Старый пароль" pf="oldPass">
							<input type="password" placeholder="Новый пароль" pf="newPass">
							<input type="password" placeholder="Подтверждение пароля" pf="newPassConfirm">

							<button class="button button-fill" pf="submit">Изменить пароль</button>
						</form>
					</div>


				</div>

			</div>

		`;
		}

	init()
		{
		super.init();
		this.changePass = new PF.Form({
			dom: {
				element: this.dom.changePassForm,
			},
			notModifyBehavior: 'none',
			fieldsConfig: {
				oldPass: {
					class: PF.Field.String,
					required: true
				},
				newPass: {
					class: PF.Field.String,
					required: true,
					minLen: 3,
				},
				newPassConfirm: {
					class: PF.Field.String,
					required: true,
					minLen: 3,
					errors: {confirmFail: 'Пароли не совпадают'},
					customValidate: (field) => {
						return field.model.newPass !== field.model.newPassConfirm ? field.errors.confirmFail : undefined;
					}
				},
			},
			errors: {
				passError: "Старый парль не верен",
			},

		});
		this.changePass.on('submit', this.changePassStart.bind(this));
		}

	changePassStart()
		{
		app.f7.preloader.show();
		app.request('/auth/change-pass', this.changePass.model.toJSON(), this.changePassFinish.bind(this));
		}

	changePassFinish(response)
		{
		app.f7.preloader.hide();
		if (response.status === 'OK')
			{
			app.router.navigate('/profile');
			app.toast("Пароль изменён");
			}
		else
			{
			this.changePass.setError(response.error);
			}
		}

	};